// DS: UI11
import React, { useCallback } from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import LinkArrowIcon from '@wix/da-ds/pkg/Icons/LinkArrow';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ViewReplies.scss';

export interface Props {
  className?: string;
  onClick: () => void;
}

// If it will be reused please extract it into its own component.
const ViewReplies: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
  onClick,
}) => {
  const clickHandler = useCallback(e => onClick(), [onClick]);
  return (
    <Flex className={s['root']} alignItems="center" onClick={clickHandler}>
      <LinkArrowIcon className={s['icon']} size={IconSize.MEDIUM} />
      <span className={s['text']}>{children}</span>
    </Flex>
  );
};
ViewReplies.displayName = 'ViewReplies';

export default ViewReplies;
